module.exports = __webpack_public_path__ + "fonts/arrow-left.svg?f64821f6";